<p>&nbsp;</p>
<div id="footer" class="container">
<header class="major">
  <h2>Let's Connect</h2>
  <h2 *ngIf="successfulsubmit"> Thanks for reaching out.  We will be in touch soon. </h2>
  <p>If you are seeking immediate support please text or call Darcy at 805-724-2229.</p>
</header>
<div class="row">
  <section class="col-12 col-12-normal col-12-narrower">
    <form #contactForm="ngForm" id="contactForm" name="contactForm" (ngSubmit)="onFormSubmit(contactForm)">
      <div class="row gtr-50 form-group">
        <div class="col-6 col-12-mobile">
          <div>
            <input name="name" id="name" placeholder="Name" type="text" [(ngModel)]="themessage.name" #name="ngModel" (focus)="namefocus=true" (blur)="namefocus=false" required minlength="1"/>
            <div *ngIf="name.touched && (name.value == '')  && !namefocus" class="warning"> Name is required. </div>
          </div>
          <div>
            <input name="email" id="email" placeholder="e-mail Address" type="text" [(ngModel)]="themessage.email" #email="ngModel" required minlength="2" [pattern]="emailPattern"(focus)="emailfocus=true" (blur)="emailfocus=false"/>
            <div *ngIf="((email.value == '') || email.invalid)  && email.touched && !emailfocus" class="warning"> Valid email address is required. </div>
          </div>
          <div>
            <input name="phone" id="phone" placeholder="Phone Number" type="text" [(ngModel)]="themessage.phone" #phone="ngModel" required minlength="10" (focus)="phonefocus = true" (blur)="phonefocus = false" [pattern]="phonePattern" />
            <div *ngIf="((phone.value == '') || phone.invalid)  && phone.touched && !phonefocus" class="warning"> Valid phone number is required. </div>
          </div>
        </div>
        <div class="col-6 col-12-mobile">
            <textarea rows=6 id="message" name="message"[(ngModel)]="themessage.message" placeholder="Message" #message="ngModel" required minlength="1" (focus)="messagefocus = true" (blur)="messagefocus = false"></textarea>
            <div *ngIf="message.touched && (message.value == '')  && !messagefocus" class="warning"> Message is required. </div>
        </div>
        <div class="col-6 col-12-mobile">
          <ul class="actions">
            <li>
              <input type="submit" value="Send Message" [disabled]="phone.invalid || email.invalid || message.invalid || name.invalid"/>
            </li>
            <li>
              <input type="reset" value="Clear" />
            </li>
          </ul>
        </div>
      </div>
    </form>
  </section>
  <section class="col-12 col-12-normal col-12-narrower contact-info">
    <div class="row gtr-50">
      <div class="col-6 col-6-normal col-12-mobile">
        <p>Darcy Wronkiewicz, IBCLC, CD(DONA)<br>
          Daylily Birth and Breastfeeding<br>
          1624 East Main Street<br>
          Ventura, CA  93001<br>
        </p>
      </div>
      <div class="col-3 col-3-normal col-12-mobile">
        <ul class="divided icons col-12-normal col-12-mobile">
          <li class="icon brands fa-instagram"><a target="daylily-ig" href="https://www.instagram.com/darcyatdaylily"><span class="extra"></span>Instagram</a></li>
          <li class="icon brands fa-facebook-f"><a target="daylily-fb" href="https://www.facebook.com/daylilyventura"><span class="extra"></span>Facebook</a></li>
        </ul>
        <!--<li class="icon brands fa-twitter"><a href="#"><span class="extra">twitter.com/</span>untitled</a></li>
                    <li class="icon brands fa-dribbble"><a href="#"><span class="extra">dribbble.com/</span>untitled</a></li>--> 
        
        <!--<li class="icon brands fa-youtube"><a href="#"><span class="extra">youtube.com/</span>untitled</a></li>
                    <li class="icon brands fa-pinterest"><a href="#"><span class="extra">pinterest.com/</span>untitled</a></li>--> 
      </div>
      <div class="col-3 col-3-normal col-12-mobile">
      </div>
    </div>
  </section>
</div>
